import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Tr, Td } from "commons";
import { convertToMoney } from "commons/src/Money";
import { format, FORMAT } from "commons/src/NuDateUtils";
import { isPrintMode } from "commons/src/QueryParameter";

import { FolioTable } from "../FolioDetails/FolioTable";

export const TransactionTypes = {
    payments: "payments",
    withdrawals: "withdrawals"
};

export function RegularTransactions({ data, nextHeader, type }) {
    if (!data.length) {
        return null;
    }

    const formatSort = sortCode => {
        if (sortCode !== undefined) {
            return sortCode.split(/(?=(?:..)*$)/).join("-");
        } else {
            return "";
        }
    };

    const getTotalAmountFor = data =>
        convertToMoney(data.reduce((acc, row) => acc + row.amount, 0));

    return (
        <Fragment>
            {type === TransactionTypes.payments && (
                <TotalTransactions data-testid="transactions-total">
                    Total: {getTotalAmountFor(data)}
                </TotalTransactions>
            )}
            <FolioTable data-testid="transactions-table-container" dense={isPrintMode()}>
                {data.map((row, index) => (
                    <Tbody key={index} data-testid="transactions-table-body">
                        <Tr>
                            <Td align="left">Type</Td>
                            <Td align="right">{row.type}</Td>
                        </Tr>
                        <AmountRow type={type} data-testid="transactions-amount-row">
                            <Td align="left">Amount</Td>
                            <Td align="right">{convertToMoney(row.amount)}</Td>
                        </AmountRow>
                        <Tr>
                            <Td align="left">Frequency</Td>
                            <Td align="right">{row.frequency}</Td>
                        </Tr>
                        <Tr>
                            <Td align="left">{nextHeader}</Td>
                            <Td align="right">
                                {format(row.nextContributionDate, FORMAT.SLASH_SEPARATED_ABBR_YR)}
                            </Td>
                        </Tr>
                        <Tr>
                            <Td align="left">Bank Details</Td>
                            <Td align="right">
                                {formatSort(row.bankSortCode)} / {row.bankAccountNumber}
                            </Td>
                        </Tr>
                        {data.length > 1 && index < data.length - 1 && (
                            <Tr>
                                <DividerTd colSpan="2">
                                    <Divider />
                                </DividerTd>
                            </Tr>
                        )}
                    </Tbody>
                ))}
            </FolioTable>
        </Fragment>
    );
}

const AmountRow = styled(Tr)`
    @media print, (min-width: ${props => props.theme.minWidth}) {
        display: ${props => (props.type === TransactionTypes.withdrawals ? "none" : "table-row")};
    }
`;

const Tbody = styled.tbody`
    tr:nth-child(5) {
        border-bottom: 0;
    }
`;

const Divider = styled.div`
    background-color: ${props => props.theme.primary};
    height: 1px;
`;

const DividerTd = styled.td`
    @media (max-width: ${props => props.theme.maxWidth}) {
        height: 1px !important;
    }
    padding: 0 2rem !important;
`;

const TotalTransactions = styled.div`
    display: none;
    margin: 0.2rem 0 0.5rem 0;
    color: ${props => props.theme.primary};

    @media (max-width: ${props => props.theme.maxWidth}) {
        display: block;
    }

    @media print {
        display: none;
    }
`;

RegularTransactions.propTypes = {
    data: PropTypes.array,
    nextHeader: PropTypes.string,
    type: PropTypes.string
};
